import { useState } from 'react';
import { Box, Collapse, Link, Stack, Typography } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { filterChipPrefix } from 'modules/candidate-profile/components/CandidateFilterChip';
import {
  Chip,
  toChip
} from 'modules/candidate-profile/components/CandidateFilterChipRail';
import {
  CandidateFilterState,
  CandidateRangeFilter
} from 'modules/candidate-profile/types/CandidateSearchFilter';
import { candidateProfileFilterNoticeSx } from 'modules/candidate-profile/styles';

type CandidateProfileFilterNoticeProps = {
  filters: CandidateFilterState[];
  labelFor: (field: string) => string;
  isSearchColumn?: (field: string) => boolean;
  describeRangeForChip?: (filter: CandidateRangeFilter) => string;
};

// Notes in the transcript that the recruiter filtered by hand since the last reply.
export const CandidateProfileFilterNotice: React.FC<
  CandidateProfileFilterNoticeProps
> = ({ filters, labelFor, isSearchColumn, describeRangeForChip }) => {
  const [expanded, setExpanded] = useState(false);

  // Worded as its chip, so a Yes/No, a range or a radius reads the same.
  const applied = filters
    .map((filter) => toChip(filter, isSearchColumn, describeRangeForChip))
    .filter((chip): chip is Chip => chip !== null);
  if (applied.length === 0) return null;

  const summary =
    applied.length === 1
      ? '1 filter manually applied'
      : `${applied.length} filters manually applied`;

  return (
    <Box sx={candidateProfileFilterNoticeSx.container}>
      <Link
        component="button"
        type="button"
        onClick={() => setExpanded((previous) => !previous)}
        aria-expanded={expanded}
        sx={candidateProfileFilterNoticeSx.toggle}
      >
        <Typography sx={candidateProfileFilterNoticeSx.summary}>
          {summary}
        </Typography>
        {expanded ? (
          <KeyboardArrowDownIcon sx={candidateProfileFilterNoticeSx.chevron} />
        ) : (
          <KeyboardArrowRightIcon sx={candidateProfileFilterNoticeSx.chevron} />
        )}
      </Link>
      <Collapse in={expanded} unmountOnExit>
        <Stack sx={candidateProfileFilterNoticeSx.list}>
          {applied.map((chip) => (
            <Typography
              key={chip.key}
              sx={candidateProfileFilterNoticeSx.listItem}
            >
              {filterChipPrefix(
                chip.mode,
                labelFor(chip.field),
                chip.isSearch,
                chip.hideMode
              )}{' '}
              {chip.values.join(', ')}
            </Typography>
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
};
